import { createPatch } from "rfc6902";
import { ArsContextState, ArsPatch } from "../interface";
import { extractDataState } from "./extractDataState";

/**
 * Adds a reversible patch entry for a state transition.
 *
 * @param previousState - State before mutation
 * @param newState - State after mutation
 * @returns Updated state with patch metadata appended when data changed
 */
export const addPatchToStack = <T>(
  previousState: ArsContextState<T>,
  newState: ArsContextState<T>,
): ArsContextState<T> => {
  const previousData = extractDataState(previousState);
  const newData = extractDataState(newState);

  const forwardPatch = createPatch(previousData, newData);
  const reversePatch = createPatch(newData, previousData);

  if (forwardPatch.length === 0) {
    return newState;
  }

  const newPatch: ArsPatch = {
    forward: forwardPatch,
    reverse: reversePatch,
  };

  const newPatches = [...previousState.patches.slice(0, previousState.ixPatch + 1), newPatch];

  return {
    ...newState,
    patches: newPatches,
    ixPatch: newPatches.length - 1,
  };
};
